export default "__VITE_ASSET__CjPTsi8J__"